import { MediaQuery } from "@constants/theme";
import { styled, SxProps, Theme } from "@mui/material/styles";
import { SlickCarousel } from "@new-components/atoms/SlickCarousel";

export const LaunchCarousel = styled(SlickCarousel)(({ theme }) => ({
  ".slick-list": {
    height: "100dvh",
    overflow: "hidden"
  },
  ".slick-arrow": {
    display: "none !important"
  },
  ".slick-dots": {
    bottom: "8px !important"
  },
  ".slick-dots li": {
    margin: 0,
    marginRight: "8px !important"
  },
  ".slick-dots li button": {
    padding: 0
  },
  ".slick-dots li button:before": {
    fontSize: "18px !important",
    width: "20px !important",
    height: "20px !important",
    color: "#fff !important"
  },
  ".slick-dots li.slick-active button:before": {
    color: "#fff !important"
  }
}));

const styles = {
  container: {
    position: "relative",
    background:
      "rgba(10,10,10,.4)"
  },
  slideWrapper: {
    minHeight: "100%",
    minWidth: "100%",
    position: "relative",
    [MediaQuery.desktop]: {}
  },
  bgWrapper: {
    minHeight: "100dvh",
    minWidth: "100%",
    position: "relative",
    [MediaQuery.desktop]: {
      minHeight: "100vh"
    }
  },
  contentWrapper: {
    width: "100%",
    position: "absolute",
    inset: 0,
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
    gap: "15%",
    color: "#FFFFFF",
    paddingBottom: "25%",
    justifyContent: "center",
    alignItems: "center",
    [MediaQuery.tablet]: {
      gap: "80px",
      paddingBottom: "80px"
    }
  },
  imageOverlay: {
    position: "absolute",
    inset: 0,
    zIndex: 1,
    opacity: 0.5,
    background: "rgba(10,10,10,1)"
  },
  detailsWrapper: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "820px",
    alignItems: "center"
  },
  logoWrapper: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    marginBottom: "24px",
    [MediaQuery.tablet]: {
      marginBottom: "26px"
    }
  },
  logoDesktop: {
    display: "none",
    [MediaQuery.tablet]: { display: "block" }
  },
  logoMobile: {
    [MediaQuery.tablet]: { display: "none" }
  },
  title: {
    fontSize: "24px",
    fontWeight: 400,
    lineHeight: "34px",
    marginBottom: "5px",
    [MediaQuery.tablet]: {
      fontSize: "46px",
      lineHeight: "60px"
    }
  },
  subTitle: {
    fontSize: "14px",
    fontWeight: 300,
    lineHeight: "22px",
    letterSpacing: "-0.4000000059604645px",
    marginBottom: "18px",
    [MediaQuery.tablet]: {
      fontSize: "22px",
      lineHeight: "35px",
      marginBottom: "30px"
    }
  },
  linkWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "fit-content",
    [MediaQuery.tablet]: {
      flexDirection: "row",
      mt: "auto"
    }
  },
  exploreLink: {
    borderRadius: "500px",
    px: 2.5,
    minHeight: "42px",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "22px",
    textDecoration: "none",
    backgroundColor: "rgba(10,10,10,.35)",
    color: "rgba(255,255,255,1)",
    marginBottom: "12px",
    width: "fit-content",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "background-color 0.25s ease",
    "&:hover": {
      backgroundColor: "rgba(10,10,10,.75)"
    }
  },
  filterContainer: {
    position: "absolute",
    bottom: "15%",
    left: "50%",
    transform: "translateX(-50%)",
    width: "100%",
    zIndex: 10,
    [MediaQuery.tablet]: {
      bottom: "80px"
    }
  },
  filterLabel: {
    fontSize: "20px",
    fontWeight: 300,
    lineHeight: "24px",
    paddingBottom: "8px",
    color: "rgba(255,255,255,1)",
    [MediaQuery.tablet]: {
      fontSize: "40px",
      fontWeight: 300,
      lineHeight: "44px",
      paddingBottom: "12px"
    }
  },
  filterWrapper: {
    height: "60px",
    [MediaQuery.desktop]: {
      // width: '60%',
    }
  }
};

export default styles as Record<keyof typeof styles, SxProps<Theme>>;
